import { parseMeHome, type MeHome } from "helpers/me-home";
import { useGET } from "hooks/useAPI";

/** The signed-in person's home: their quotes, policies and arrangements.
 * `home` is null until the read succeeds; `failed` is true when it did
 * not, so a caller can tell an empty home from an unread one. */
export function useMeHome(enabled = true): {
  home: MeHome | null;
  isLoading: boolean;
  failed: boolean;
} {
  const { data, isLoading, error } = useGET(
    enabled ? "/me/home" : null,
    undefined,
    {
      shouldRetryOnError: false,
    },
  );
  return {
    home: data === undefined ? null : parseMeHome(data),
    isLoading,
    failed: Boolean(error),
  };
}
